import { useLocation } from "react-router-dom";

export const useBreadcrumb = () => {
  const location = useLocation();

  const getBreadcrumbs = () => {
    const pathMap = {
      "/about": { name: "Who we are", parent: "/" },
      "/services": { name: "What we do", parent: "/" },
      "/contact": { name: "Connect", parent: "/" },
      "/terms-conditions": { name: "Terms & Conditions", parent: "/" },
      "/privacy-policy": { name: "Privacy Policy", parent: "/" },
    };

    const paths = location.pathname.split("/").filter((path) => path);
    const breadcrumbs = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.nextcosmostechnology.com/",
      },
    ];

    let currentPath = "";
    paths.forEach((path, index) => {
      currentPath += `/${path}`;
      const routeInfo = pathMap[currentPath];

      if (routeInfo) {
        breadcrumbs.push({
          "@type": "ListItem",
          position: index + 2,
          name: routeInfo.name,
          item: `https://www.nextcosmostechnology.com${currentPath}`,
        });
      }
    });

    return breadcrumbs;
  };

  return { getBreadcrumbs };
};
